// @ts-nocheck
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  styled,
  Typography,
} from "@mui/material";
import styles from "../contractDetails.module.css";
import { Add } from "@mui/icons-material";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import DraggableTool from "./DraggableTool";
import { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import TextIcon from "../../../assets/images/text-icon.svg";
import SignatureIcon from "../../../assets/images/signature-icon.svg";

// const dData = [
//   {
//     type: "Text",
//     list: [
//       { type: "Text", text: "Hello" },
//       { type: "Text", text: "There" },
//       { type: "Text", text: "Hii" },
//       { type: "Text", text: "Address" },
//       { type: "Text", text: "New" },
//     ],
//   },
//   {
//     type: "Signature",
//     list: [
//       { type: "Signature", text: Sign },
//       { type: "Signature", text: Sign },
//       { type: "Signature", text: Sign },
//       { type: "Signature", text: Sign },
//       { type: "Signature", text: "New" },
//     ],
//   },
// ];
function getContractPresetData(preset) {
  return [
    {
      type: "Text",
      list: [
        ...(preset?.savedText?.map((item) => {
          return { type: "Text", text: item?.text, ...item };
        }) || []),
        { type: "Text", text: "New", button: "New" },
      ],
    },
    {
      type: "Signature",
      list: [
        ...(preset?.savedSignature?.map((item) => {
          return { type: "Signature", text: item?.url, ...item };
        }) || []),
        { type: "Signature", text: "New", button: "New" },
      ],
    },
  ];
}

const LeftContract = ({ setFields, currPage }) => {
  const { contractPresets } = useSelector((state) => state?.contract);
  const [demoData, setDemoData] = useState([]);

  const updatePresets = useCallback(() => {
    setDemoData(getContractPresetData(contractPresets));
  }, [contractPresets]);

  useEffect(() => {
    updatePresets();
  }, [updatePresets]);

  return (
    <Box className={`${styles["side-container"]} custom-scroll-design`}>
      {demoData?.map((item, i) => {
        return (
          <Box
            sx={{
              "@media (min-width: 900px) and (max-width: 1480px)": {
                width: "100%",
              },
            }}
            key={i}
          >
            <Typography
              className={styles["saved-signature-title"]}
              sx={{
                ...(i == 1 ? { marginTop: "1rem !important" } : {}),
                "@media (min-width: 900px) and (max-width: 1480px)": {
                  marginTop: "0px !important",
                },
              }}
            >
              <img
                src={i == 0 ? TextIcon : SignatureIcon}
                alt={i == 0 ? "Text Icon" : "Signature Icon"}
              />
              {item?.type}
            </Typography>
            {item?.list?.map((dragItme, dIdx) => {
              return (
                <DraggableTool
                  key={dIdx}
                  item={dragItme}
                  setFields={setDemoData}
                  setFieldsOnPdf={setFields}
                  currPage={currPage}
                  idx={dIdx}
                />
              );
            })}
          </Box>
        );
      })}
    </Box>
  );
};

LeftContract.propTypes = {
  setFields: PropTypes?.func,
  currPage: PropTypes.number,
};

export default LeftContract;